import { ReviewStep } from '../types';

export const getStepNumber = (stepNumber: number) => {
  if (!stepNumber) {
    return 0;
  }
  return String(stepNumber).padStart(2, '0');
};

const getEntityName = (
  id: string,
  projectUsers: EntityData[],
  projectCompanies: EntityData[],
  projectRoles: EntityData[],
) => {
  const user = projectUsers.find((user) => user.autodeskId === id);
  if (user) {
    return user.name || '';
  }
  const company = projectCompanies.find(
    (company) => company.memberGroupId === id,
  );
  if (company) {
    return company.name || '';
  }
  const role = projectRoles.find((role) => role.memberGroupId === id);
  if (role) {
    return role.name || '';
  }
  return '';
};

export const sortTasksByRequiredAndAlphabeticallyAllTypes = (
  step: ReviewStep,
  projectUsers: EntityData[],
  projectCompanies: EntityData[],
  projectRoles: EntityData[],
) => {
  const tasks = step.tasks.map((task) => ({
    ...task,
    userName: getEntityName(
      task.assignedTo,
      projectUsers,
      projectCompanies,
      projectRoles,
    ).toLowerCase(),
  }));
  tasks.sort((a, b) => {
    if (a.isRequired < b.isRequired) {
      return 1;
    } else if (a.isRequired > b.isRequired) {
      return -1;
    } else if (a.userName < b.userName) {
      return -1;
    } else if (a.userName > b.userName) {
      return 1;
    }
    return 0;
  });
  return tasks;
};

interface EntityData {
  autodeskId?: string;
  memberGroupId?: string;
  isLoading: boolean;
  name?: string;
  company?: string;
}
